import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class SeperatorPlaceholderButton extends ToolbarButton {
    constructor() {
        super('', '', 'placeholder_button');
    }
    _action() {
        return;
    }
}
